import { render, staticRenderFns } from "./unitDefectPage.vue?vue&type=template&id=9ec6fcca&scoped=true&"
import script from "./unitDefectPage.vue?vue&type=script&lang=js&"
export * from "./unitDefectPage.vue?vue&type=script&lang=js&"
import style0 from "./unitDefectPage.vue?vue&type=style&index=0&id=9ec6fcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec6fcca",
  null
  
)

export default component.exports